import { Text } from "@certn/cascadia";
import { CascadiaColor } from "@certn/cascadia-tokens";
import { CascadiaJsonFormContext } from "@certn/forms/src/CascadiaJsonFormContext";
import get from "lodash.get";
import { useContext, useMemo } from "react";
import { ItemProps } from "../types";
import { getTextColor } from "./utils";
import { getMatchingConditionDefinition } from "../../utils";

export function ConditionalText(props: ItemProps) {
  const { values } = useContext(CascadiaJsonFormContext);
  const {
    uischema: { options },
  } = props;

  const item = useMemo(() => get(values, props.path), [values, props.path]);
  const conditionDefinition = useMemo(
    () =>
      getMatchingConditionDefinition(
        item,
        options?.subtitle.conditionDefinitions
      ),
    [options?.subtitle.conditionDefinitions, item]
  );
  const textColor = useMemo(
    () => getTextColor(item, options?.subtitle),
    [item, options?.subtitle]
  );

  if (conditionDefinition?.value) {
    return <Text color={textColor}>{conditionDefinition.value}</Text>;
  }
  const defaultValue = options?.subtitle?.defaultValue;
  if (defaultValue != null && defaultValue !== "") {
    const defaultTextColor =
      (options?.subtitle?.defaultTextColor as CascadiaColor) || "text-weak";
    return <Text color={defaultTextColor}>{defaultValue}</Text>;
  }
  return <></>;
}
